var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelopeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 0H1C0.4475 0 0 0.4475 0 1V17C0 17.5525 0.4475 18 1 18H23C23.5525 18 24 17.5525 24 17V1C24 0.4475 23.5525 0 23 0ZM22.497 1L12.332 10.0355C12.142 10.2045 11.856 10.2035 11.6675 10.036L1.5025 1H22.497ZM1 17V1.8915L11.0035 10.784C11.2875 11.036 11.6435 11.162 12 11.162C12.3565 11.162 12.7125 11.036 12.9965 10.7835L23 1.8915V17H1Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeIcon);
export default __webpack_public_path__ + "static/media/envelope_icon.7facd4a2e82450798a091ca0872504e9.svg";
export { ForwardRef as ReactComponent };